export const UPLOAD_FILE_ACTION = "UPLOAD_FILE_ACTION";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_RESET = "UPLOAD_FILE_RESET";